

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import DataTable from "../DataTable.vue"

import FieldMapping from "./FieldMapping.vue"
import EventMapping from "./EventMapping.vue"
import DataForm from "../DataForm.vue"

import { Integration, IntegrationColumn } from "@/types/integration"

import api from "@/services/api"
import integrationApi from "@/services/api_Integrations"

import cloneDeep from "lodash/cloneDeep"
import { Field, Template } from "@/types"
import { CaseColumn } from "@/types/caseColumns"

const setup = namespace("setup")

@Component({
	components: {
		"data-form": DataForm
	}
})
export default class IntegrationConfiguration extends Vue {
	@Prop()
	value!: IntegrationConfiguration

	@Prop()
	integration!: Integration

	get configColumns (): CaseColumn[] {
		if (!this.integration || !this.integration.setupColumns) {
			return []
		}

		return this.integration.setupColumns.map(column => {
			return {
				key: column.key,
				label: column.title,
				dataType: column.dataType
			} as CaseColumn
		})
	}

	mounted () {
		if (!this.value) {
			this.$emit("input", {})
		}
	}
}

